import React, { useEffect } from 'react';
import './Blog.css'
import AOS from 'aos';
import 'aos/dist/aos.css';

const Blog = (props) => {
    const { title, img, link, date } = props.blog;

    useEffect(() => {
        AOS.init({
            duration: 800,
        })
    }, [])

    return (
        <div className="col pb-5" data-aos="fade-up"
            data-aos-anchor-placement="top-bottom">
            <div className="card h-100 project-hover">
                <div className="blog-img"><img src={img} className="card-img-top" height="250" alt="..." /></div>
                <div className="card-body">
                    <span className='blog-sub-title'>{date}</span>
                    <h5 className="card-title py-2">{title}</h5>
                    <a href={link} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noreferrer">
                        <button type="button" className="btn text-white" style={{ background: "#1A5E9D" }}>Read More</button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Blog;